/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align */

import {ProjectElement}         from './project.element';
import {ProjectElementType}     from './project.element.type';

import {
  Blob,
  BlobType
}                    from '../blob';

import {
  Project
}            from '../project';
import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";

/**
 *
 * @class ManifestElement
 *
 * @brief root element of library projects
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
@ProjectElementFactoryDecorator('ManifestElement')
export class ManifestElement extends ProjectElement {

  /** standard constructor */
  constructor(
    project: Project,
         id: string,
     parent: ProjectElement
  ) {

    super(project, id, ProjectElementType.Manifest);

    this._acceptsElements.push(ProjectElementType.Blob);

    this._enabled     = true;
    this._label       = 'Manifest';
    this._icon        = '';
    this._elementKind = 'Manifest';

    if (parent) {

      this._project.addElement(this, parent);
    }

  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring ManifestElement");
  }
}
